// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"2f479632","453":"8feb9f12","656":"9b5a677c","801":"c84336f9"}[chunkId] + ".chunk.js";
};